'use strict';

class InvalidChallengeError extends Error {
}

exports.InvalidChallengeError = InvalidChallengeError;
//# sourceMappingURL=errors.js.map
